import React, { useState } from "react";
import "../../css/CRUDModal.css";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { CircularProgress } from "@mui/material";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";

const SendToCarrierModal = ({ show, handleClose, columnData, callApi }) => {

  const [selectedCourier, setSelectedCourier] = useState("");
  const [allData, setAllData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [courierData, setCourierData] = useState([]);
  const [error, setError] = useState("");

  const courierCompanies = [
  {
    name: "SHREE_TIRUPATI",
    label: "SHREE TIRUPATI",
    priority: 1,
    estimate: "2-3 Days",
  },
];
  
  const handleBack = () => {
    handleClose();
    setSelectedCourier("");
  };

  const handleRadioChange = (name) => {
    setSelectedCourier(name);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    callApi(allData);
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "660px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <LocalShippingOutlinedIcon
                    style={{ color: "#ff7a00", fontSize: "28px" }}
                  />
                  <h5 className="modal-title main-title font-medium">
                    Courier Company
                  </h5>
                </div>
                <HighlightOffIcon
                  onClick={handleBack}
                  style={{ cursor: "pointer", zIndex: 10 }}
                />
              </div>
              <form onSubmit={handleSubmit}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  {loading ? (
                    <CircularProgress />
                  ) : courierData ? (
                    <div
                      className="table-container max-h-[550px] overflow-auto custom-scrollbar"
                      style={{ width: "100%" }}
                    >
                      <div className="table-wrapper">
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th
                                style={{ textAlign: "center" }}
                                className="!bg-[#ffe8d4]"
                              >
                                Select
                              </th>
                              <th className="!bg-[#ffe8d4]">Name</th>
                              <th
                                className="!bg-[#ffe8d4]"
                                style={{ textAlign: "center" }}
                              >
                                Priority
                              </th>
                              <th className="!bg-[#ffe8d4]">Estimate Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {courierCompanies.map((courier, index) => (
                              <tr key={index}>
                                <td style={{ textAlign: "center" }}>
                                  <input
                                    type="radio"
                                    name="courier"
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      cursor: "pointer",
                                    }}
                                    checked={selectedCourier === courier.name}
                                    onChange={() => {
                                      handleRadioChange(courier.name);
                                      setAllData({
                                        ...courierData,
                                        courierName: courier.name,
                                      });
                                    }}
                                  />
                                </td>
                          
                                <td>{courier.label}</td>
                          
                                <td style={{ textAlign: "center" }}>
                                  {courier.priority}
                                </td>
                          
                                <td>{courier.estimate}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#888",
                        fontStyle: "italic",
                      }}
                    >
                      {error?.response || "No courier details available."}
                    </div>
                  )}
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back !rounded-[8px]"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-submit !rounded-[8px]"
                    disabled={!selectedCourier}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SendToCarrierModal;
